import { Link } from 'react-router';

// Sessão 1 Frente A — quick links pra deep-link em investigation pages.

interface Props {
  hwid?: string;
  account_id?: string;
  ip?: string;
  className?: string;
}

export function CrossCorrelationLinks({ hwid, account_id, ip, className = '' }: Props) {
  const links: { label: string; to: string }[] = [];
  if (hwid)       links.push({ label: '🔍 HWID',    to: `/investigations/hwid/${encodeURIComponent(hwid)}` });
  if (account_id) links.push({ label: '🔍 Account', to: `/investigations/account_id/${encodeURIComponent(account_id)}` });
  if (ip)         links.push({ label: '🔍 IP',      to: `/investigations/ip/${encodeURIComponent(ip)}` });

  if (links.length === 0) return null;

  return (
    <div className={`flex gap-2 flex-wrap ${className}`}>
      {links.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          className="inline-block px-2 py-0.5 text-xs rounded bg-blue-900 text-blue-100 hover:bg-blue-700"
        >
          {l.label}
        </Link>
      ))}
    </div>
  );
}

export default CrossCorrelationLinks;
